(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    if (!window.themeAccordionBlockInitialized) {
    window.themeAccordionBlockInitialized = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.js-accordion-block .accordion-button');
      if (!button) return;

      const content = button.nextElementSibling;
      const isOpen = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', String(!isOpen));
      content.hidden = isOpen;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    Plyr.setup('.plyr, .plyr__video-embed');
  });
  } catch(e) { console.error(e); }
})();

})();
